import { MatPaginatorIntl } from '@angular/material/paginator';
import { Injectable } from '@angular/core';

/**
 * Begründung: Hierbei handelt es sich um eine generische Datei für die deutsche Paginierung.
 */
@Injectable({
  providedIn: 'root'
})
export class GermanPaginatorIntl extends MatPaginatorIntl {
  constructor() {
    super();

    this.itemsPerPageLabel = 'Zeilen pro Seite';
    this.nextPageLabel = 'Nächste Seite';
    this.previousPageLabel = 'Vorherige Seite';
    this.firstPageLabel = 'Erste Seite';
    this.lastPageLabel = 'Letzte Seite';

    this.getRangeLabel = (page: number, pageSize: number, length: number) => {
      if (length === 0 || pageSize === 0) {
        return `0 von ${length}`;
      }

      const startIndex = page * pageSize;
      const endIndex = Math.min(startIndex + pageSize, length);

      return `Seite ${page + 1} von ${Math.ceil(length / pageSize)} / Zeile ${startIndex + 1}-${endIndex} von ${length}`;
    };
  }
}
